import { EMPTY_ARRAY } from '@unifyapps/carbon/consts/empty';
import type { ThemeType } from '@unifyapps/defs/theme/types';
import { useMemo } from 'react';
import { useThemeEntitiesByIds } from './useThemeEntitiesByIds';

/**
 * Fetches a single interface theme by ID — needed before first paint for the
 * theme/snackbar merge in InterfaceAppProviders. Endpoint selection (public/private,
 * pre/post login) lives in useThemeEntitiesByIds.
 *
 * The request body is built by the same core code as useInterfaceThemes' default-theme
 * query, so react-query shares one cache entry — the default theme downloads once.
 */
export default function useGetInterfaceThemeById(interfaceThemeId?: string) {
  const themeIds = useMemo(
    () => (interfaceThemeId ? [interfaceThemeId] : (EMPTY_ARRAY as string[])),
    [interfaceThemeId],
  );

  const { themes, isLoading, error } = useThemeEntitiesByIds(themeIds);
  const themeEntity: ThemeType | undefined = themes[0];

  return { themeEntity, isLoading, error };
}
